/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-14 10:19:39
 */
export const AjaxMethod = {
	post: 'post',
	get: 'get',
	put: 'put',
	delete: 'delete',
	head: 'head',
	patch: 'patch',
};

export const PLATFORM_ALL = {
	label: '不限',
	value: '0',
};

export const PLATFORM_DY = {
	label: '抖音',
	value: '1',
	icon: 'i-douyin',
};

export const PLATFORM_KS = {
	label: '快手',
	value: '2',
	icon: 'i-kuaishou',
};
export const PLATFORM_SP = {
	label: '视频号',
	value: '3',
	icon: 'i-shipin',
};
export const PLATFORM_XHS = {
	label: '小红书',
	value: '4',
	icon: 'i-xhs',
};

export const PLATFORM_LIST = [PLATFORM_DY, PLATFORM_KS, PLATFORM_SP];

export const PLATFORM_ALL_LIST = [PLATFORM_ALL, PLATFORM_DY, PLATFORM_KS, PLATFORM_SP];

export const PLATFORM_ID_LIST = [+PLATFORM_DY.value, +PLATFORM_KS.value, +PLATFORM_SP.value];

export const PLATFORM_ALL_ID_LIST = [+PLATFORM_ALL.value + PLATFORM_DY.value, +PLATFORM_KS.value, +PLATFORM_SP.value];

export const PLATFORM_OBJ = {
	1: PLATFORM_DY,
	2: PLATFORM_KS,
	3: PLATFORM_SP,
};

export const PLATFORM_ALL_OBJ = {
	0: PLATFORM_ALL,
	1: PLATFORM_DY,
	2: PLATFORM_KS,
	3: PLATFORM_SP,
};
export const tzRoleType = {
	id: 1,
	name: '管理员',
	HomePageUrl: '/index/home',
	icon: 'ic_signin_tuanzhang',
	label: 'role-label-tz',
};
export const zsRoleType = {
	id: 2,
	name: '招商运营',
	HomePageUrl: '/index/home',
	icon: 'ic_16_detail_shop',
	label: 'role-label-zs',
};
export const drRoleType = {
	id: 3,
	name: '达人商务',
	HomePageUrl: '/index/home',
	icon: 'ic_signin_zhubo',
	label: 'role-label-dr',
};
export const cgRoleType = {
	id: 8,
	name: '超管',
	HomePageUrl: '/index/home',
	icon: 'ic_signin_zhubo',
	label: 'role-label-cg',
};
export const roleTypes = {
	1: tzRoleType,
	2: zsRoleType,
	3: drRoleType,
};

export const roleAuths = {
	dr: drRoleType.id,
	zs: zsRoleType.id,
	tz: tzRoleType.id,
};
export const roleSelectOptions = [zsRoleType, drRoleType];

export const startSpread = {
	label: '已开启',
	styleClass: 'yx-color-success',
};
export const stopSpread = {
	label: '已停止',
	styleClass: 'yx-color-danger',
};
export const spreadStatus = {
	1: startSpread,
	2: stopSpread,
};

export const palletUploading = {
	value: 0,
	label: '商品同步中',
	cellText: '商品同步中...',
	styleClass: 'status-warning',
};
export const palletUploadSomeSuccess = {
	value: 1,
	label: '部分上传成功',
	cellText: '部分上传成功',
	styleClass: 'status-warning',
};
export const palletUploadAllSuccess = {
	value: 2,
	label: '全部上传成功',
	cellText: '全部上传成功',
	styleClass: 'status-success',
};
export const palletUploadFail = {
	value: 3,
	label: '上传失败',
	cellText: '上传失败',
	styleClass: 'status-error',
};
export const palletStatus = [palletUploading, palletUploadSomeSuccess, palletUploadAllSuccess, palletUploadFail];

export const normalRoutes = ['/404', '/reject', '/bind'];
export const whiteList = ['/login', '/invite', '/register'];

// 30天销售额选项
export const saleList = [
	{ value: 0, label: '全部' },
	{ value: 1, label: '1w以下' },
	{ value: 2, label: '1w-10w' },
	{ value: 3, label: '10w-100w' },
	{ value: 4, label: '100w-1000w' },
	{ value: 5, label: '1000w以上' },
];

// 粉丝量选项
export const fansList = [
	{ value: 0, label: '全部' },
	{ value: 1, label: '10w以下' },
	{ value: 2, label: '10w-100w' },
	{ value: 3, label: '100w-300w' },
	{ value: 4, label: '300w-500w' },
	{ value: 5, label: '500w-1000w' },
	{ value: 6, label: '1000w以上' },
];

// 达人等级选项
export const talentGradeList = [
	{ value: -1, label: '不限' },
	{ value: 0, label: 'LV0' },
	{ value: 1, label: 'LV1' },
	{ value: 2, label: 'LV2' },
	{ value: 3, label: 'LV3' },
	{ value: 4, label: 'LV4' },
	{ value: 5, label: 'LV5' },
	{ value: 6, label: 'LV6' },
	{ value: 7, label: 'LV7' },
];

// 快速时间筛选
export const fastDatePick = [
	{ id: 2, name: '昨日', days: 1 },
	{ id: 3, name: '7天', days: 7 },
	{ id: 4, name: '15天', days: 15 },
	{ id: 5, name: '30天', days: 30 },
];

// 月销售额
export const monthLiveSaleList = [
	{ value: 1, label: '<1万' },
	{ value: 2, label: '1万-10万' },
	{ value: 3, label: '10万-50万' },
	{ value: 4, label: '50万-100万' },
	{ value: 5, label: '100万-1000万' },
	{ value: 6, label: '1000万-5000万' },
	{ value: 7, label: '>5000万' },
];

// 场均销售额ks
export const ksLiveSaleList = [
	{ value: 11, label: '<500' },
	{ value: 12, label: '500-1000' },
	{ value: 13, label: '1000-5000' },
	{ value: 1, label: '5000-1w' },
	{ value: 2, label: '1w-10w' },
	{ value: 3, label: '10w-50w' },
	{ value: 4, label: '50w-100w' },
	{ value: 5, label: '100w-200w' },
	{ value: 6, label: '200w-500w' },
	{ value: 7, label: '500w-1000w' },
	{ value: 8, label: '1000w以上' },
];

// 场均销售额dy
export const dyLiveSaleList = [
	{ value: 0, label: '全部' },
	{ value: 11, label: '<500' },
	{ value: 12, label: '500-1000' },
	{ value: 13, label: '1000-5000' },
	{ value: 1, label: '5000-1w' },
	{ value: 2, label: '1w-10w' },
	{ value: 3, label: '10w-50w' },
	{ value: 4, label: '50w-100w' },
	{ value: 5, label: '100w-200w' },
	{ value: 6, label: '200w-500w' },
	{ value: 7, label: '500w-1000w' },
	{ value: 8, label: '1000w以上' },
];

// 近90天直播带货次数
export const liveCountList = [
	{ value: 0, label: '全部' },
	{ value: 1, label: '0-10' },
	{ value: 2, label: '11-50' },
	{ value: 3, label: '51-100' },
	{ value: 4, label: '100以上' },
];

// 粉丝年龄
export const fansAgeList = [
	{ value: '0', label: '不限' },
	{ value: '1', label: '18岁以下居多' },
	{ value: '2', label: '18～23岁居多' },
	{ value: '3', label: '24～30岁居多' },
	{ value: '4', label: '31～40岁居多' },
	{ value: '5', label: '41～50岁居多' },
	{ value: '6', label: '50岁以上居多' },
];

// 粉丝地区
export const fansAreaList = [
	{ value: '0', label: '不限' },
	{ value: '1', label: '一线城市居多' },
	{ value: '2', label: '二线城市居多' },
	{ value: '3', label: '三线城市居多' },
	{ value: '4', label: '四线城市居多' },
	{ value: '5', label: '五线城市居多' },
];

// 粉丝性别
export const fansSexList = [
	{ value: '0', label: '不限' },
	{ value: '1', label: '男性居多' },
	{ value: '2', label: '女性居多' },
];

// 商品均价
export const avgPriceList = [
	{ value: 0, label: '全部' },
	{ value: 10, label: '10以下' },
	{ value: 20, label: '10-50' },
	{ value: 30, label: '50-100' },
	{ value: 40, label: '100-500' },
	{ value: 50, label: '500-1000' },
	{ value: 60, label: '1000以上' },
];

// 活动类型
export const activityTypeList = [
	{ value: 0, label: '全部' },
	{ value: 1, label: '普通' },
	{ value: 2, label: '专属' },
	{ value: 3, label: '合作' },
];

// 商品来源
export const productSourceList = [
	{ value: 0, label: '全部' },
	{ value: 1, label: '货盘商品' },
	{ value: 2, label: '活动商品' },
];

//菜单名称
export const menuType = {
	gruop: '1',
	library: '2',
	waste: '3',
	pallet: '4',
};

//商品状态
export const productStatus = {
	up: '0', //上架
	down: '1', //下架
};

//待播表链接状态
export const linkStatus = {
	toboUp: '0', //待上传链接
	tobeCheck: '1', //带校验链接
	finished: '2', //已完成
};

//推广状态
export const promoteStatus = {
	open: '1', //推广中
	close: '0', //推广关闭
};

//合作状态
export const cooperationStatus = {
	ongoing: '1', //合作中
	end: '2', //合作结束
	pause: '3', //停止合作（暂停合作，可恢复）
};

//物流状态
export const deliveryStatus = {
	notShipped: '1', //未发货
	shipped: '2', //已发货
	transit: '3', //运输中
	arrived: '4', //已到货
};

//是否拒绝发货
export const refuseDelivery = {
	yes: '1', //是
	no: '2', //否
};

//带货状态
export const affirmStatus = {
	unconfirm: '1', //未确认
	confirm: '2', //确认
	refuse: '3', //拒绝带货
};

//变动状态
export const changeStatus = {
	yes: '1', //是
	no: '2', //否
};

//活动同步类型
export const activityType = {
	myActivity: '1', //我的招商活动列表
	myActivityGoods: '2', //我的招商活动商品
	mayActivitiy: '3', //可报名活动列表
	mayActivitiyGoods: '4', //可报名活动商品
	goodsLibrary: '5', //商品库活动同步
};

// 活动状态选项
export const activityStatusList = [
	{ label: '全部', value: '0' },
	{ label: '报名未开始', value: '1' },
	{ label: '报名中', value: '2' },
	{ label: '报名已结束', value: '3' },
];

//抖音我的活动商品报名状态
export const dyMyActivityUpStateList = [
	{ audit_status_desc: '待审核', audit_status: '0' },
	{ audit_status_desc: '合作中', audit_status: '1' },
	{ audit_status_desc: '未通过', audit_status: '2' },
	{ audit_status_desc: '合作已终止', audit_status: '3' },
	{ audit_status_desc: '合作前取消', audit_status: '4' },
	{ audit_status_desc: '合作已到期', audit_status: '6' },
];

//ks活动详情
export const ksUpActivityType = {
	Unpublished: '1', //未发布
	Published: '2', //已发布
	promotion: '3', //推广中
	end: '4', //已结束
};

//ks活动详情列表
export const ksAuditStatusType = {
	toBeReviewed: '1', //待审核
	Approved: '2', //审核通过
	rejected: '3', //审核拒绝
	Invalid: '5', //已失效
};

// 抖音活动状态选项
export const activityStatusDyList = [
	{ label: '全部', value: '0' },
	{ label: '报名未开始', value: '1' },
	{ label: '报名中', value: '2' },
	{ label: '报名已结束', value: '3' },
];

// 快手活动状态选项
export const activityStatusKsList = [
	{ label: '全部', value: '0' },
	{ label: '已发布', value: '2' },
	{ label: '推广中', value: '3' },
	{ label: '已结束', value: '4' },
];

// 商品推广状态
export const goodsPromoteStatusObj = {
	promotion: 1, //推广中
	productOff: 2, //已失效-商品下架
	Invalid: 3, //已失效-活动失效
	timeOut: 4, //已失效-暂停推广
	toBeEffective: 5, //待生效
};

//crm筛选授权状态
export const authStatusList = [
	{ value: 0, label: '全部' },
	{
		label: '未授权',
		value: '0',
	},
	{
		label: '已授权',
		value: '1',
	},
];

export const sampleStutas = {
	all: '0', //全部
	tobeShipped: '1', //待发货
	Shipped: '2', //已发货
	transit: '3', //运输中
	Arrived: '4', //已到货
	confirmDelivery: '5', //确认带货
	rejectShipment: '6', //拒绝发货
	refuseDelivery: '7', //拒绝带货
	Closed: '8', //已关闭
	Audit: '10', //待审核
	noPass: '11', //审核不通过
};

// 异步状态
export const ASYNC_DEFAULT_STATUS = 'default';
export const ASYNC_PENDING_STATUS = 'pending';
export const ASYNC_SUCCESS_STATUS = 'success';
export const ASYNC_FAIL_STATUS = 'fail';

// 授权结果状态（用于第三方返回首页时附带在链接上的status值）
export const AUTH_RESULT_STATUS_REPEAT_SUCCESS = 0;
export const AUTH_RESULT_STATUS_REPEAT_FAIL = 1;
export const AUTH_RESULT_STATUS_REPEAT_AUTHED = 2;
export const AUTH_RESULT_STATUS_HAS_AUTHED = 3;
export const AUTH_RESULT_STATUS_ARR = [
	AUTH_RESULT_STATUS_REPEAT_SUCCESS,
	AUTH_RESULT_STATUS_REPEAT_FAIL,
	AUTH_RESULT_STATUS_REPEAT_AUTHED,
	AUTH_RESULT_STATUS_HAS_AUTHED,
];

// 首页
export const defaultBaseInfo = {
	// "host_id": "2",  //系统id
	// "company_name": "超佣团",  //公司名字
	// "domain": "test-partner-api.chaoyongtuan.com",  //公司域名
	// "domain_record_no": "浙ICP备2022008875号", //域名备案号
	// "website_title": "超佣团", //网站名字
	// "official_account_code": "https://cdn.chaoyongbushou.com/partner/t/chaoyongtuan_wx.jpg", //公众号二维码  252*244
	// "products_fail_code": "https://cdn.chaoyongbushou.com/wx/20210720/vWaBaNQwIND390d0344da0796e0987db234fa3e367df.png",//导入货盘失败时的微信客服二维码 320*320
	// "partner_auth_code": "https://cdn.chaoyongbushou.com/wx/20211124/1637739587964-098e41d3c8074f5a4778db527fe593c.png",//团长一键授权提示框微信客服二维码 400*400
	// "anchor_fail_code": "https://cdn.chaoyongbushou.com/wx/20210720/vWaBaNQwIND390d0344da0796e0987db234fa3e367df.png",//批量导入达人失败时的微信客服二维码 320*320
	// "account_full_code": "https://cdn.chaoyongbushou.com/seller/img/contact-wx.7ed0fa64.jpeg",//子账号已满提示弹窗中客服微信号，客服微信二维码  391*371
	// "account_full_number":"chaoyongmao1",//微信号
	// "login_logo": "https://cdn.chaoyongbushou.com/seller/img/logo.9d8122db.png", // 登录页logo 480*200
	// "tab_logo": "https://partner.chaoyongtuan.com/cyt-favicon.ico",  //tab的logo 32*32
	// "roLe_page_logo": "https://cdn.chaoyongbushou.com/seller/img/logo.9d8122db.png",  //选择角色页面logo 480*200
	// "left_top_logo": "https://cdn.chaoyongbushou.com/partner/cyt/logo.png",  //主页左上角logo  254*60
	// "applet_partner_auth_logo": "https://cdn.chaoyongbushou.com/partner/cyt/logo_1.png" //小程序达人，团长授权页页面logo  120*120
};

// 抽屉尺寸
export const DRAWER_SIZE_SMALL = '500px';
export const DRAWER_SIZE_NORMAL = '800px';
export const DRAWER_SIZE_LARGE = '1080px';

//  数据视角
//  数据视角-全部（用于排行榜总榜传参）
export const DATAVIEW_ALL = 0;
//  数据视角-店铺运营
export const DATAVIEW_SHOP_PARTNER_TAG = 10;
//  数据视角-达人运营
export const DATAVIEW_ANCHOR_PARTNER_TAG = 20;
//  数据视角-查看全部数据
export const DATAVIEW_ALL_DEPT = 30;
//  数据视角-无用户标签
export const DATAVIEW_NO_TAG = 40;
// 数据视角-标签集合
export const DATA_VIEW_OBJ = {
	[drRoleType.id]: DATAVIEW_ANCHOR_PARTNER_TAG,
	[zsRoleType.id]: DATAVIEW_SHOP_PARTNER_TAG,
};

// 数据权限
// 数据权限-全部数据
export const DEPT_DATA_SCOPE_ALL = 10;
// 数据权限-部门及以下数据
export const DEPT_DATA_SCOPE_DEPT = 30;
// 数据权限-部门及以下数据
export const DEPT_DATA_SCOPE_DEPTS = 20;
// 数据权限-本人数据
export const DEPT_DATA_SCOPE_PERSONAL = 40;
// 数据权限-数据权限列表
export const dataPower = [
	{ value: 10, label: '全部数据权限' },
	{ value: 30, label: '部门数据权限' },
	{ value: 20, label: '部门及以下数据权限' },
	{ value: 40, label: '仅本人数据权限' },
];

// 弹窗宽度
export const DIALOG_SIZE_WIDTH = {
	small: '400px',
	normal: '600px',
	large: '800px',
};

// 弹窗宽度
export const DRAWER_SIZE_WIDTH = {
	small: '500px',
	default: '600px',
	normal: '800px',
	large: '1080px',
};

//样品订单审核状态
export const AUDIT_STATUS_OPEN = '1'; //开启
export const AUDIT_STATUS_CLOSE = '2'; //关闭

//页面配置项 名称不能重复
export const pageConfig = {
	performanceManageListTelant: 'partner_result_telant', //达人业绩
	performanceManageListBd: 'partner_result_bd', //招商业绩
	shopLibrarySearch: 'shopLibrarySearch', //商品库筛选
	trusteeshipSearch: 'trusteeshipSearch', //托管商品筛选
	tobeClaimedSearch: 'tobeClaimedSearch', //团长商品筛选
	sampleOrderSearch: 'sampleOrderSearch', //样品订单筛选
	performanceManageSearch: 'performanceManageSearch', //样品订单筛选
};

export const syncSkuSource = {
	detail_pc: 'detail_pc', //同步sku 商品详情
	share: 'share', //同步sku 分享商品
	edit_product: 'edit_product', //同步sku 编辑商品机制
	hand_card: 'hand_card', //同步sku 上传手卡
	reshipment: 'reshipment', //同步sku 补寄样品申请
	apply_sample: 'apply_sample', //同步sku 申样
};

export default {
	DRAWER_SIZE_SMALL,
	DRAWER_SIZE_NORMAL,
	DRAWER_SIZE_LARGE,
	DATAVIEW_ALL,
	DATAVIEW_SHOP_PARTNER_TAG,
	DATAVIEW_ANCHOR_PARTNER_TAG,
	DATAVIEW_ALL_DEPT,
	DATAVIEW_NO_TAG,
	DATA_VIEW_OBJ,
	PLATFORM_ALL,
	PLATFORM_DY,
	PLATFORM_KS,
	PLATFORM_SP,
	PLATFORM_XHS,
	PLATFORM_LIST,
	PLATFORM_ALL_LIST,
	PLATFORM_ID_LIST,
	PLATFORM_ALL_ID_LIST,
	PLATFORM_OBJ,
	PLATFORM_ALL_OBJ,
	DEPT_DATA_SCOPE_ALL,
	DEPT_DATA_SCOPE_DEPT,
	DEPT_DATA_SCOPE_DEPTS,
	DEPT_DATA_SCOPE_PERSONAL,
	dataPower,
	cgRoleType,
	tzRoleType,
	AjaxMethod,
	zsRoleType,
	drRoleType,
	roleTypes,
	roleAuths,
	startSpread,
	stopSpread,
	spreadStatus,
	palletUploading,
	palletUploadSomeSuccess,
	palletUploadAllSuccess,
	palletUploadFail,
	palletStatus,
	normalRoutes,
	saleList,
	fansList,
	talentGradeList,
	fastDatePick,
	monthLiveSaleList,
	ksLiveSaleList,
	dyLiveSaleList,
	liveCountList,
	fansAgeList,
	fansAreaList,
	fansSexList,
	menuType,
	productStatus,
	linkStatus,
	promoteStatus,
	cooperationStatus,
	deliveryStatus,
	refuseDelivery,
	affirmStatus,
	changeStatus,
	authStatusList,
	ASYNC_DEFAULT_STATUS,
	ASYNC_PENDING_STATUS,
	ASYNC_SUCCESS_STATUS,
	ASYNC_FAIL_STATUS,
	AUTH_RESULT_STATUS_REPEAT_SUCCESS,
	AUTH_RESULT_STATUS_REPEAT_AUTHED,
	AUTH_RESULT_STATUS_HAS_AUTHED,
	AUTH_RESULT_STATUS_ARR,
	DRAWER_SIZE_WIDTH,
	DIALOG_SIZE_WIDTH,
	syncSkuSource,
	whiteList,
};
